import { render } from "./ProcessedDocument.vue?vue&type=template&id=e97f881e&scoped=true"
import script from "./ProcessedDocument.vue?vue&type=script&lang=js"
export * from "./ProcessedDocument.vue?vue&type=script&lang=js"

import "./ProcessedDocument.vue?vue&type=style&index=0&id=e97f881e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97f881e"]])

export default __exports__